import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton, Typography, Paper, Tooltip } from "@mui/material";
import AnalyticsIcon from "@mui/icons-material/Analytics";

const DataStudentGrid = ({ data, viewSessionInfo }) => {
  // Define columns for the DataGrid
  const columns = [
    {
      field: "first_name",
      headerName: "First name",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2">
          {`${params.row.first_name}`}
        </Typography>
      ),
    },
    {
      field: "middle_name",
      headerName: "Middle name",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2">
          {`${params.row.middle_name}`}
        </Typography>
      ),
    },
    {
      field: "last_name",
      headerName: "Last name",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2">
          {`${params.row.last_name}`}
        </Typography>
      ),
    },
    { field: "session_count", headerName: "Session count", flex: 1 },
    { field: "assessment_count", headerName: "Assessment count", flex: 1 },
    {
      field: "actions",
      headerName: "Session info",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={"view session data"} placement="right">
        <IconButton
          color="secondary"
          onClick={() => viewSessionInfo(params.row.id)}
        >
          <AnalyticsIcon />
        </IconButton>
        </Tooltip>
      ),
    },
  ];

  // Pagination state
  const [pageSize, setPageSize] = useState(10);
  return (
    <Paper sx={{ height: "calc(100vh - 350px)", width: "100%" }}>
      <DataGrid
        rows={data}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 25]}
        pagination
        disableSelectionOnClick
        disableColumnMenu
        sx={{
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center", // <-- This vertically centers content
          }}
        }
      />
    </Paper>
  );
};

export default DataStudentGrid;